import { jsonMember, jsonObject } from 'typedjson';
import {
  DictionaryCountryResponse,
  PhoneNumberWithPrefixResponse,
} from '@web/shared/module/dictionary';
import { Nillable } from '@web/utils';

@jsonObject
export class PublicSubscriptionBillingAddressResponse {
  @jsonMember(String)
  public readonly city!: string;

  @jsonMember(String)
  public readonly dignity!: string;

  @jsonMember(String)
  public readonly email!: string;

  @jsonMember(String)
  public readonly firstName!: string;

  @jsonMember(String)
  public readonly lastName!: string;

  @jsonMember(PhoneNumberWithPrefixResponse)
  public readonly phone!: PhoneNumberWithPrefixResponse;

  @jsonMember(String)
  public readonly postCode!: string;

  @jsonMember(String)
  public readonly streetLine1!: string;

  @jsonMember(DictionaryCountryResponse)
  public readonly country!: DictionaryCountryResponse;

  @jsonMember(String)
  public readonly streetLine2?: Nillable<string>;

  @jsonMember(String)
  public readonly state?: Nillable<string>;

  @jsonMember(String)
  public readonly companyName?: Nillable<string>;

  @jsonMember(String)
  public readonly companyNip?: Nillable<string>;
}
